module.exports = __webpack_public_path__ + "static/media/home.6ded32af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/home.svg
// module id = 1080
// module chunks = 36